<template>
  <Page>
    <template #kicker>
      <nuxt-link to="/shop"> Shop </nuxt-link>
    </template>
  </Page>
</template>

<script setup>
const route = useRoute();

console.log("ROUTE!");
console.log(route);

const categoryHandle = ref(
  route.params.category_handle[route.params.category_handle.length - 1]
);

// TODO: Validate shop category route structure somehow
// If top-level, check against Top-Level Category list
// If not top level, request Collection then check its parent?

const query = gql`
  query ($handle: String) {
    collection(handle: $handle) {
      id
      title
      handle
      description(truncateAt: 300)
      descriptionHtml
      seo {
        title
        description
      }
      image {
        url
      }
      products(first: 10) {
        edges {
          cursor
          node {
            title
            featuredImage {
              urlThumbnail: url(transform: { maxWidth: 450 })
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            handle
            id
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
      subcollections: metafield(namespace: "custom", key: "subcollections") {
        references(first: 30) {
          nodes {
            ... on Collection {
              id
              handle
              title
              products(first: 10) {
                nodes {
                  handle
                  id
                  title
                  featuredImage {
                    urlThumbnail: url(transform: { maxWidth: 450 })
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const variables = { handle: categoryHandle.value, first: 10 };

const { data, error } = await useAsyncQuery(
  `category-${categoryHandle.value}`,
  { query, variables }
);

console.log(error);

if (!data.value || !data.value.collection)
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: true,
  });

// if (error) navigateTo("/404");

// const { data: pageData } = await useAsyncData(
//   `category-${route.params.category_handle}`,
//   async () => {
//     return $apiFetch({
//       body: JSON.stringify({
//         query: query.loc.source.body,
//         variables: {
//           handle: route.params.category_handle,
//         },
//       }),
//     });
//   }
// );

// if (!pageData.value.collection) navigateTo("/404");

// Computed
const category = computed(() => data?.value?.collection ?? null);
const products = computed(() => category?.value?.products.edges ?? null);
const subCategories = computed(() =>
  category.value.subcollections
    ? category.value.subcollections.references.nodes
    : []
);

const fetchCategory = async () => {};

route.meta.title = category?.value?.title || "";
route.matched[route.matched.length - 1].meta.title =
  category?.value?.title || "";

useSeoMeta({
  title: () => `${category.value?.title} - Shop`,
  description: () => category?.value?.description || "",
});
</script>
